<template>
    <v-container fluid class="pa-5 pb-16 elevation-1">
     <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
        <h1 class="text-h4 font-weight-bold d-flex">
          <v-btn icon color="blue">
            <v-icon>mdi-chart-donut</v-icon>
          </v-btn>
          <span class="ml-2">Mi Consumo</span> 
         <!-- <v-btn :disabled="loading" class="btn-refresh pa-2 ml-auto" @click="cargarDatos"> {{ loading ? "Actualizando..." : "Actualizar" }} </v-btn> -->
        </h1>
      </v-sheet>
  

    <div v-if="error" class="alert error">{{ error }}</div>

    <div v-if="usage && !loading" class="contenido">
      <!-- Banner de bloqueo -->
      <div v-if="usage.blocked" class="alert blocked">
        ⚠️ Has alcanzado tu límite de uso o no tienes asignado un disponible. Contacta a tu Manager para
        ampliarlo o asignar un disponible.
      </div>

      <!-- Cards de resumen -->
      <div class="stats">
        <div class="card">
          <span class="label">Gastado</span>
          <span class="valor">${{ Number(usage.used || 0).toFixed(4) }}</span>
        </div>
        <div class="card">
          <span class="label">Disponible</span>
          <span class="valor verde">${{ Number(usage.remaining || 0).toFixed(4) }}</span>
        </div>
        <div class="card">
          <span class="label">Límite</span>
          <span class="valor">${{ Number(usage.limit || 0).toFixed(2) }}</span>
        </div>
        <div class="card">
          <span class="label">Llamadas</span>
          <span class="valor">{{ history.length }}</span>
        </div>
      </div>

      <!-- Barra de progreso -->
      <div class="barra-container">
        <div class="barra-info">
          <span>Uso actual</span>
          <span class="porcentaje">{{ Number(usage.percentage || 0).toFixed(2) }}%</span>
        </div>
        <div class="barra">
          <div
            class="barra-fill"
            :style="{
              width: Math.min(usage.percentage, 100) + '%',
              background: colorBarra,
            }"
          ></div>
        </div>
      </div>

      <!-- Breakdown por aplicación -->
      <section v-if="porApp.length">
        <h2>Consumo por módulo</h2>
        <div class="apps-grid">
          <div v-for="app in porApp" :key="app.app" class="app-card">
            <h3>{{ app.app }}</h3>
            <p><b>{{ app.llamadas }}</b> llamadas</p>
            <p>{{ formatoTotal(app.costo) }} gastado</p>
            <p class="small">{{ app.input.toLocaleString() }} tokens in /
                              {{ app.output.toLocaleString() }} tokens out</p>
          </div>
        </div>
      </section>

      <!-- Historial detallado -->
      <section>
        <div class="hist-header">
          <h2>Historial de llamadas</h2>
          <select v-model="filtroApp">
            <option value="todas">Todas</option>
            <option v-for="app in porApp" :key="app.app" :value="app.app">
              {{ app.app }}
            </option>
          </select>
        </div>

        <v-table v-if="historialFiltrado.length" hover>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>App</th>
              <th>Tokens in</th>
              <th>Tokens out</th>
              <th>Costo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="h in pagedRegister" :key="h.id">
              <td>{{ formatoFecha(h.created_at) }}</td>
              <!-- <td class="modelo">{{ h.model_id.split(".").pop() }}</td> -->
              <td><span class="tag">{{ h.source_app }}</span></td>
              <td>{{ h.input_tokens.toLocaleString() }}</td>
              <td>{{ h.output_tokens.toLocaleString() }}</td>
              <td>{{ formatoCosto(h.cost_usd) }}</td>
            </tr>
          </tbody>
        </v-table>
         <!-- FOOTER / PAGINACIÓN -->
          <div
            class="d-flex align-center justify-space-between flex-wrap ga-3 px-4 pb-4 table-footer"
          >
            <div class="d-flex align-center ga-2">
              <span class="text-caption text-medium-emphasis">{{
                $t("paginacion")
              }}</span>

              <v-select
                v-model="itemsPerPage"
                :items="[5,10,15,20]"
                density="compact"
                variant="outlined"
                hide-details
                class="items-select"
                style="max-width: 110px"
              />
            </div>

            <v-pagination
              v-model="page"
              :length="pageCount"
              density="comfortable"
              :total-visible="6"
            />
          </div>
        
        <!-- <p v-else class="vacio">No hay llamadas registradas todavía.</p> -->
      </section>
    </div>

    <div v-else-if="loading" class="loader">Cargando tu información...</div>
  
  </v-container>
</template>
<script setup>

import { ref, computed, onMounted } from "vue";
import {calculateUsage, getUsageHistory} from "@/api/usoModel"

const usage = ref(null);
const history = ref([]);
const loading = ref(true);
const error = ref("");
const filtroApp = ref("todas");
const itemsPerPage=ref(10)
const page=ref(1)

async function cargarDatos() {
  loading.value = true;
  error.value = "";
  try {

    const resUsage= await calculateUsage();
    const resHistory=await getUsageHistory();
    console.log("consumo ", resHistory)
    // const [resUsage, resHistory] = await Promise.all([
    //   axios.get("/api/calculate/usage/"),
    //   axios.get("/api/calculate/usage/history/"),
    // ]);
    usage.value = resUsage.data;
    history.value = Array.isArray(resHistory.data)
      ? resHistory.data
      : resHistory.data.results || [];
      console.log(history)
  } catch (e) {
    error.value = "No se pudo cargar tu información de consumo.";
    console.error(e);
  } finally {
    loading.value = false;
  }
}

onMounted(cargarDatos);

// Color de la barra según porcentaje
const colorBarra = computed(() => {
  if (!usage.value) return "#10b981";
  const p = usage.value.percentage;
  if (p >= 100) return "#dc2626";
  if (p >= 80) return "#f59e0b";
  if (p >= 50) return "#eab308";
  return "#10b981";
});

// Breakdown por source_app
const porApp = computed(() => {
  const agrupado = {};
  for (const h of history.value) {
    const app = h.source_app || "otros";
    if (!agrupado[app]) {
      agrupado[app] = { llamadas: 0, costo: 0, input: 0, output: 0 };
    }
    agrupado[app].llamadas += 1;
    agrupado[app].costo  += parseFloat(h.cost_usd);
    agrupado[app].input  += h.input_tokens;
    agrupado[app].output += h.output_tokens;
  }
    // Convierte el objeto en un arreglo de pares [clave,valor], el map recorre cada elemento destructurando app, stats
    // se queda con la app y los estados como propiedades [{app: Ejemplo1, llamada:1 , outputs: 2500}] ... stats es un operador spredd de propagacion
  return Object.entries(agrupado).map(([app, stats]) => ({ app, ...stats }));
});

// Listado filtrado del historial
const historialFiltrado = computed(() => {
  if (filtroApp.value === "todas") return history.value;
  return history.value.filter(h => h.source_app === filtroApp.value);
});
const pageCount=computed(()=>{
    
    const total =historialFiltrado.value.length
    const per = Number(itemsPerPage.value) || 10;
    
    return Math.max(1, Math.ceil(total / per));
});
const pagedRegister=computed(()=>{
    const per = Number(itemsPerPage.value) || 10;
      const start = (page.value - 1) * per;
      return historialFiltrado.value.slice(start, start + per);
});



function formatoFecha(iso) {
  return new Date(iso).toLocaleString("es-MX", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}
function formatoCosto(v) { return `$${parseFloat(v).toFixed(6)}`; }
function formatoTotal(v) { return `$${parseFloat(v).toFixed(4)}`; }
</script>


<style scoped>
.mis-usos {
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px;
  font-family: system-ui, -apple-system, sans-serif;
  color: #1f2937;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
h1 { font-size: 26px; margin: 0; }

.btn-refresh {
  background: #d0d5e6;
  color: rgb(30, 29, 29);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  
}
.btn-refresh:disabled { opacity: 0.6; cursor: wait; }

.alert {
  padding: 14px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
}
.alert.error   { background: #fee2e2; color: #991b1b; }
.alert.blocked { background: #fef3c7; color: #92400e; border: 1px solid #fbbf24; }

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 18px;
  display: flex;
  flex-direction: column;
}
.label { color: #6b7280; font-size: 13px; margin-bottom: 6px; }
.valor { font-size: 22px; font-weight: 700; }
.verde { color: #059669; }

.barra-container { margin-bottom: 32px; }
.barra-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 14px;
}
.porcentaje { font-weight: 600; }
.barra {
  width: 100%;
  height: 14px;
  background: #e5e7eb;
  border-radius: 7px;
  overflow: hidden;
}
.barra-fill {
  height: 100%;
  border-radius: 7px;
  transition: width 0.4s ease, background 0.3s ease;
}

section { margin-bottom: 28px; }
h2 { font-size: 18px; margin-bottom: 12px; }

.apps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}
.app-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 14px;
  border-radius: 8px;
}
.app-card h3 { margin: 0 0 8px 0; font-size: 14px; text-transform: uppercase; color: #4b5563; }
.app-card p  { margin: 4px 0; font-size: 14px; }
.small { color: #6b7280; font-size: 12px; }

.hist-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hist-header select {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  font-size: 14px;
}
th, td { padding: 10px 12px; text-align: left; border-bottom: 1px solid #f3f4f6; }
th { background: #f9fafb; font-weight: 600; color: #374151; }
tr:last-child td { border-bottom: none; }

.modelo { font-family: monospace; font-size: 12px; color: #4b5563; }
.tag {
  display: inline-block;
  padding: 2px 8px;
  background: #dbeafe;
  color: #1e40af;
  border-radius: 4px;
  font-size: 12px;
}
.vacio { color: #6b7280; font-style: italic; }
.loader { text-align: center; padding: 40px; color: #6b7280; }
</style>